/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useForm from "../../../hooks/useForm";
import { ControlTable } from "../../../components/Table";
import { getParams } from "../../../utils/params";
import { getFinanceAccountSubList } from "../../../apis/tax-portal/financeAccountSub";
import TaxAccountSubHometax from "./TaxAccountSubHometax";
import { isEmpty } from "../../../utils/lodashExtend";
import NoData from "../../NoData/NoData";


const TaxAccountSubHometaxList = (props) => {
  const { setHeaderButtons, accountInfo } = props;

  const [fields] = useState(
    [
      {
        title: "홈택스 아이디",
        key: "userId",
      },
      {
        title: "비밀번호",
        key: "userPw",
        onValue: (data) => data ? '등록됨' : '등록안됨'
      },
      {
        title: "직원",
        key: "employeeIdx",
        type: 'profile',
        useEmpty: true
      },
      {
        title: "생성일",
        type: 'date',
        key: "createdTime",
        width: 130,
      },
      {
        title: "최근 수정일",
        type: 'date',
        key: "updatedTime",
        width: 130,
      },

    ]);

  const {
    form,
    setSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
  } = useForm({
    limit: 10,
    offset: 0,
    search: {}
  });

  useEffect(() => {
    setSubmit(submit);
    submit(form);
  }, []);

  const submit = (form) => {
    setIsLoading(true);
    getFinanceAccountSubList(getParams(form))
      .then((res) => {
        setList(res.data.data);
        setTotal(res.data.total)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };




  const onSelect = (data) => {
    setFormData(data)
    setMode('modify')
    setDetailOpen(true)
  }


  const [formData, setFormData] = useState({});
  const [mode, setMode] = useState("create");
  const [detailOpen, setDetailOpen] = useState(false);

  useEffect(() => {
    if (setHeaderButtons) {
      setHeaderButtons([
        {
          label: "부서사용자생성",
          action: () => {
            setFormData(null)
            setMode('create')
            setDetailOpen(true);
          },
        },
      ])
    }
  }, [])

  return (
    <div>
      <div className="tax-singo-wrap">
        {!isEmpty(accountInfo) ?
          <ControlTable
            isLoading={isLoading}
            fields={fields}
            list={list}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            onSelect={onSelect}
          />
          : <>
            <NoData text={'기본정보 탭에서 인증서 먼저 등록 해주세요.'} />
          </>}
        <TaxAccountSubHometax
          accountInfo={accountInfo}
          open={detailOpen}
          setOpen={setDetailOpen}
          mode={mode}
          setMode={setMode}
          formData={formData}
          setFormData={setFormData}
          submit={reSubmit}
        />

      </div>
    </div>
  );
};

export default TaxAccountSubHometaxList;
